module.exports = __webpack_public_path__ + "img/ADMINISTRADOR.8256ac91.jpg";